import { axiosInstanceWithCredentials } from "./base";

export function getTournaments(params) {
  return axiosInstanceWithCredentials.get("/tournaments", {
    params
  });
}
export function addTournament(data) {
  return axiosInstanceWithCredentials.post(`/tournament/`,data);
}
export function getTournament(id) {
  return axiosInstanceWithCredentials.get(`/tournament/${id}`);
}

export function updateTournament(id,data) {
  return axiosInstanceWithCredentials.put(`/tournament/${id}`,data);
}

export function deleteTournament(id) {
  return axiosInstanceWithCredentials.delete(`/tournament/${id}`);
}
